import Swiper, {Autoplay, Navigation, Scrollbar} from 'swiper';

Swiper.use([Autoplay, Navigation, Scrollbar]);

const selectors = {
  slider: '.js-gallery-slider',
};

const cardsSlider = () => {
  const container = document.querySelector(selectors.slider);

  if (!container) return;

  const slider = new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 10,

    autoplay: {
      delay: 7000,
    },

    breakpoints: {
      1140: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },

    navigation: {
      prevEl: '.js-gallery-slider-prev',
      nextEl: '.js-gallery-slider-next',
      disabledClass: 'c-gallery-arrows__arrow--disable',
    },

    scrollbar: {
      el: '.js-gallery-slider-scrollbar',
      draggable: true,
    },
  });

  return slider;
};

export default cardsSlider;
